export enum TextEnhancementFormField {
  ENHANCED_TEXT = "ENHANCED_TEXT"
}
